import { PaletteMode, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Container from '@mui/material/Container';
import ToggleColorMode from './ToggleColorMode';
import logo from '../logo_escapade.jpg';

const logoStyle = {
    height: '50px',
    marginLeft: '10px',
    borderRadius: '50px',
    cursor: 'pointer',
};

interface AppAppBarProps {
    mode: PaletteMode;
    toggleColorMode: () => void;
}

function AppAppBar({ mode, toggleColorMode }: AppAppBarProps) {
    return (
        <div>
            <AppBar
                position='fixed'
                sx={{
                    boxShadow: 0,
                    bgcolor: 'transparent',
                    backgroundImage: 'none',
                    mt: 2,
                    overflowX: 'hidden',
                }}>
                <Container maxWidth='lg'>
                    <Toolbar
                        variant='regular'
                        sx={(theme) => ({
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            flexShrink: 0,
                            borderRadius: '999px',
                            bgcolor:
                                theme.palette.mode === 'light'
                                    ? 'rgba(255, 255, 255, 0.4)'
                                    : 'rgba(0, 0, 0, 0.4)',
                            backdropFilter: 'blur(24px)',
                            maxHeight: 40,
                            border: '1px solid',
                            borderColor: 'divider',
                            boxShadow:
                                theme.palette.mode === 'light'
                                    ? `0 0 1px rgba(85, 166, 246, 0.1), 1px 1.5px 2px -1px rgba(85, 166, 246, 0.15), 4px 4px 12px -2.5px rgba(85, 166, 246, 0.15)`
                                    : '0 0 1px rgba(2, 31, 59, 0.7), 1px 1.5px 2px -1px rgba(2, 31, 59, 0.65), 4px 4px 12px -2.5px rgba(2, 31, 59, 0.65)',
                        })}>
                        <Box
                            sx={{
                                flexGrow: 1,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'left',
                                px: 0,
                            }}>
                            <img
                                src={logo}
                                style={logoStyle}
                                alt='logo of escapp website'
                                onClick={() => window.scrollTo(0, 0)}
                            />
                            <Typography
                                variant='body1'
                                component='span'
                                onClick={() =>
                                    window.scrollTo({
                                        top: 0,
                                        behavior: 'smooth',
                                    })
                                }
                                sx={{ cursor: 'pointer' }}
                                color={(theme) =>
                                    theme.palette.mode === 'light'
                                        ? 'black'
                                        : 'white'
                                }
                                marginLeft={2}
                                borderRight={1}
                                borderColor='divider'
                                pr={2}>
                                Recherche
                            </Typography>
                            <Typography
                                variant='body1'
                                component='span'
                                onClick={() =>
                                    window.scrollTo({
                                        top: document.getElementById('faq')
                                            ?.offsetTop,
                                        behavior: 'smooth',
                                    })
                                }
                                sx={{ cursor: 'pointer' }}
                                color={(theme) =>
                                    theme.palette.mode === 'light'
                                        ? 'black'
                                        : 'white'
                                }
                                marginLeft={2}>
                                FAQ
                            </Typography>
                        </Box>
                        <Box
                            sx={{
                                display: { xs: 'none', md: 'flex' },
                                gap: 0.5,
                                alignItems: 'center',
                            }}>
                            <ToggleColorMode
                                mode={mode}
                                toggleColorMode={toggleColorMode}
                            />
                        </Box>
                    </Toolbar>
                </Container>
            </AppBar>
        </div>
    );
}

export default AppAppBar;
